import { Component } from '@angular/core';

@Component({
  selector: 'app-submitted',
  imports: [],
  templateUrl: './submitted.component.html',
  styleUrl: './submitted.component.css'
})
export class SubmittedComponent {

}
